import { getAPIPath } from '@interhyp/platform-request';
import { useTranslationContext } from '@interhyp/util-translation';
import { useEffect } from 'react';

export function useTranslation(): void {
  const { addTranslation } = useTranslationContext();

  useEffect(() => {
    async function getTranslation() {
      const response = await fetch(`${getAPIPath('content')}/api/graphql`, {
        method: 'POST',
        body: JSON.stringify({
          operationName: null,
          query:
            '{\n  neutral: publishedContentsByLanguageAndContext(language: "de", context: "neutral.credit")\n  global: publishedContentsByLanguageAndContext(language: "de", context: "global")\n}\n',
          variables: {},
        }),
      });
      const content = await response.json();

      if (content.data) {
        addTranslation({ ...content.data.neutral });
        addTranslation({ ...content.data.global });
      }
    }

    getTranslation();
  }, [addTranslation]);
}
